<template>
  <div 
    class="yunxiao teacher clue assign">
    <div class="main">
      <van-form       
        class="full-page" 
        input-align="right" 
        ref="form">
          <van-cell >
            <template #title>
              <span 
                @click="$router.back()" 
                style="color: var(--c1);" 
                data-test="multi-modify-btn-back-choose">返回选择</span>
            </template>
            <template>
              <div style="color: var(--g6); text-align: center;" @click="showPopup=true">
                已选<span  style="color: var(--c1);">{{clueObjs.length}}</span>条意向(点击查看)
              </div>
            </template>
          </van-cell>
          <van-field
            readonly
            clickable
            v-model="params.campusName"
            label="报名校区"
            :right-icon="'arrow'"
            placeholder="请选择"
            @click.stop="chooseCampus()"
          />
          <van-field        
            v-model="params.followTeacherName"
            :right-icon="'arrow'"
            placeholder="请选择负责沟通跟进的老师"
            readonly
            @click.stop="choiceTeacher()"
          >
            <template #label>
              <div class="check-teacher" >
                跟进人
                <div style="font-size: var(--fs-md); color: var(--g6);white-space: nowrap;">
                  负责沟通跟进的老师
                </div>
              </div>
            </template>
          </van-field>
      </van-form>
    </div>
     <div class="footer">
      <van-button
        square round
        block
        type="primary"
        @click="submitAssign"
        loading-text="保存中..."
        :loading="isSubmit"
        data-test="add-clue-page-btn-add">
          保存
        </van-button>
    </div>
    <van-popup 
      :safe-area-inset-bottom="true"
      class="show-choosed-popup"
      v-model="showPopup" 
      position="bottom" 
      :get-container="()=>this.$el"      
      :closeable="!clueObjs.length"
      :style="{ height: '372px' }" >
      <div class="title">
        已选意向({{clueObjs.length}})
        <span class="clear-btn" v-if="clueObjs.length" @click="clearClueObjs">
          清空
        </span>
      </div>
      <div class="body">
        <div class="van-hairline--bottom" v-for="(item, idx) of clueObjs" :key="item.id">
          <div>
            {{ item.name }}
          </div>
          <div class="l2 van-ellipsis">
            {{ item.contactsPhone }}
          </div>
          <van-icon name="clear" class="clear-icon" @click="removeClue(idx)" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: 'ClueAssign',
  data () {
    return {
      pageTitle: '分配意向',
      isSubmit: false,
      clueObjs: [],
      showPopup: false,

      params: {
        clueIds: [],
        campusId: '',
        campusName: '',
        // followTeacherId: app.teacher.user.id,
        followTeacherId: '',
        followTeacherName: '',
        needCheck: true,
      }
    }
  },
  methods: {
    submitAssign () {
      if (!this.params.clueIds.length) {
        this.$toast('请选择要分配的意向');
        return false;
      }
      if (!this.params.campusId) {
        this.$toast('请选择报名校区');
        return false;
      }
      if (!this.params.followTeacherId) {
        this.$toast('请选择跟进人');
        return false;
      }
      this.showLoading();
      this.isSubmit = true;
      let {clueIds, campusId, followTeacherId, needCheck} = this.params;

      this.$api.clueDistributeClue({clueIds, campusId, followTeacherId, needCheck})
        .then(res=> {
          this.params.needCheck = true;
          if (res.code === 200) {            
            this.isSubmit = false;
            this.$toast.success('操作成功');
            this.$router.back();
            app.vue.$emit('assign-clue-success');
            return false;
          }
          if (res.code === 810000005) {            
            this.isSubmit = false;
            let len = res.data.intentionClueDos.length;
            let name = res.data.intentionClueDos[0].name
            let nameInfos = `未找到${len === 1 ? name : `${name}等${len}条意向`},请重新选择需要分配的意向`
            this.$toast(nameInfos)
            return false;
          }
          if (res.code === 810000006) {
            this.$toast.clear();   
            this.isSubmit = false;
            let len = res.data.intentionClueDos.length;
            let name = res.data.intentionClueDos[0].name
            let message = `${len === 1 ? name : `${name}等${len}条意向`}已有跟进人，分配后原跟进人将被替换或清除，是否继续分配？`  
            vant.Dialog.confirm({
              title: '提示',
              message,
              confirmButtonText: '继续分配',
            })
              .then(() => {
                this.params.needCheck = false;
                this.submitAssign();
              })
              .catch(() => {
                console.log('取消了。。');
                this.params.needCheck = true;
              });       

            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{          
          this.params.needCheck = false;
          this.isSubmit = false;
          console.log(err)
          if (!err.code) {
            this.$toast.clear();
          }
        })

    },
    async chooseCampus() {
      // 选择校区
      let res = await app.x3.side.xsCampus({
        id: this.params.campusId,
      });
      if ((!res && this.params.campusId) || (res.id && this.params.campusId !==res.id)) {
        this.params.followTeacherId = '';
        this.params.followTeacherName = '';
      }
      this.params.campusId = res ? res.id : 0;
      this.params.campusName = res ? res.name : "";
    },
    async choiceTeacher() {
      if (!this.params.campusId) {
        this.$toast.fail('请先选择报名校区');
        return false;
      }
      let res = await app.x3.side.xsTeacher({
        id: this.params.followTeacherId,
        params: {
          campusIds: [this.params.campusId],
          statusList: [1],
        }
      });

      this.params.followTeacherId = res ? res.id : 0;
      this.params.followTeacherName = res ? res.name : "";
    },
    clearClueObjs() {
      this.params.clueIds.splice(0);
      this.clueObjs.splice(0);
      this.showPopup = false;
      
      app.vue.$emit('clear-choosed-clues');
    },
    removeClue(idx) {
      this.params.clueIds.splice(idx, 1);
      this.clueObjs.splice(idx, 1);
      app.vue.$emit('choosed-clue-remove', idx);
    },
  },
  created () {
    let {cluesIds, choosedList } = app.ls.get("multi-clues-assign-obj") || {};
    this.params.clueIds = cluesIds;
    this.clueObjs = choosedList;
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.clue.assign{
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
  }
  .multi-modify.choosed-nav{

    height: 48px;
    background: var(--white);
    border-bottom: 1px solid var(--g3);
    overflow: hidden;
    >div{
      padding: 12px 16px;
      .van-cell__title{
        width: auto;
        flex: unset;
      }
    }

  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: var(--cl-xs);
    }
  }
  .show-choosed-popup{
    display: flex;
    flex-direction: column;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    color: var(--g8);
    > .title {
      position: relative;
      margin-bottom: calc(var(--gap) * 8);
      height: calc(var(--w) * 48);
      font-size: var(--fs-lg);
      line-height: calc(var(--w) * 48);
      font-weight: 500;
      text-align: center;
      .clear-btn {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right: calc(var(--gap) * 16);
        color: var(--tlc);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        height: var(--lh-md);
      }
    }
    > .body {
      padding: 0 calc(var(--gap) * 16);
      overflow: auto;
      > div {
        position: relative;
        display: block;
        padding: 0 calc(var(--gap) * 18) calc(var(--gap) * 7) 0;
        margin-bottom: calc(var(--gap) * 16);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        .l2 {
          margin: calc(var(--gap) * 4) 0 0;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
        }
        .clear-icon {
          position: absolute;
          top: 50%;
          right: 0;
          color: var(--g6);
          transform: translateY(-50%);
        }
      }
    }
  }
  ::v-deep.van-field__label,
  ::v-deep.van-field__value{
    font-size:var(--fs-lg);      
    color: var(--g8);
  }
  ::v-deep.van-field__label{
    color: var(--g7);
  }
}
</style>